import React, { useState } from "react";
import axios from "axios";
import { BellIcon } from "@heroicons/react/24/outline";
import { toast } from "sonner";
import Notification from "./Notification";

const NotificationBell = ({ label }) => {
  const [open, setOpen] = useState(false);
  const [notification, setNotification] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasUnread, setHasUnread] = useState(false);

  const accessToken = localStorage.getItem("access");

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        "https://api.upswap.app/api/notifications/",
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const data = response.data || [];
      setNotification(data);
      setHasUnread(data.some((n) => !n.is_read));
      setOpen(true);
    } catch (error) {
      console.error("Error fetching notifications:", error);
      toast.error("Failed to load notifications");
    } finally {
      setLoading(false);
    }
  };

  const handleBellClick = () => {
    if (!accessToken) {
      toast.warning("Please login to view notifications.");
      return;
    }
    fetchNotifications();
  };

  const handleMarkedAsRead = (id) => {
    setNotification((prev) =>
      prev.map((n) => (n.id === id ? { ...n, is_read: true } : n))
    );
    setHasUnread(false);
  };

  return (
    <>
      {/* Notification icon */}
      <div
        className="relative cursor-pointer text-gray-600 hover:text-black"
        onClick={handleBellClick}
      >
        {label && <span>{label}</span>}
        {loading ? (
          <div className="h-6 w-6 border-2 border-gray-300 border-t-orange-500 rounded-full animate-spin" />
        ) : (
          <>
            <BellIcon className="h-6 w-6" />
            {hasUnread && (
              <span className="absolute -top-1 -right-1 h-2 w-2 rounded-full bg-red-500 border border-white"></span>
            )}
          </>
        )}
      </div>

      {!open && (
        <style>{`
          body {
            margin-right: 0;
            transition: margin-right 0.3s ease;
          }
        `}</style>
      )}

      {/* Notification Drawer */}
      {open && (
        <Notification
          open={open}
          onClose={() => setOpen(false)}
          notification={notification}
          onMarkedAsRead={handleMarkedAsRead}
        />
      )}
    </>
  );
};

export default NotificationBell;
